import { LEGAL } from '@affily/shared/constants';
import { useAuth } from '../hooks/useAuth.jsx';

/**
 * "Rather do it together?" — a free setup call, for someone stuck on their
 * first program, profile or tracking. Opens the scheduling page set in
 * SETUP_CALL_URL; without one, an email to us asking for a call.
 */
export function SetupCallLink({ topic = 'setting up Affily', className = '' }) {
  const { setupCallUrl, user } = useAuth();
  const subject = encodeURIComponent(`Help with ${topic}`);
  const body = encodeURIComponent(
    `Hi,\n\nCould we have a quick call to help me with ${topic}?\n\nGood times for me:\n\nAccount: ${user?.email ?? ''}\n`,
  );
  const href = setupCallUrl ?? `mailto:${LEGAL.contactEmail}?subject=${subject}&body=${body}`;

  return (
    <p className={`text-xs text-ink-muted ${className}`}>
      Rather do it together?{' '}
      <a
        href={href}
        target={setupCallUrl ? '_blank' : undefined}
        rel={setupCallUrl ? 'noopener noreferrer' : undefined}
        className="font-medium text-accent hover:underline"
      >
        Book a free setup call
      </a>{' '}
      — we’ll do it with you on screen.
    </p>
  );
}
